import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get, isEmpty } from 'lodash';

/**
 * expected response
 * {
 *     data: {
 *         stores: {
 *             locationId: []
 *         }
 *     }
 * }
 *
 * @param environmentVariables
 * @param user
 * @param banner
 *
 */

export type Address = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  postalCode: string;
  stateCode: string;
};

function storesByAddressService(environmentVariables, user, address: Address) {
  const headers = get(environmentVariables, 'GEO_STORES_BY_ADDRESS_API_HEADERS_POST_V2');
  const banner = get(headers, 'x-swy-banner');

  const options = {
    headers: {
      Authorization: `Bearer ${get(user, 'authToken')}`,
      ...headers,
    },
  };

  const params = new URLSearchParams();
  params.append('zipCoverage', 'FULL');
  params.append('bannerFilter', banner);
  params.append('banner', banner);

  return snsAxiosClient(options).post(
    get(environmentVariables, 'STORES_BY_ADDRESS', 'stores_by_address'),
    {
      address: address,
    },
    {
      params,
    },
  );
}

export default storesByAddressService;
